import type { LocaleCode, ResolvedLocale } from "../types";

import { deriveLocaleMetadata } from "../country/derive-locale-metadata";
import { getLocaleDefinition } from "../registry/locale-registry";

// Consent and metadata come from the validated, frozen registry; no runtime
// re-validation of LocaleConsent fields (types + satisfies at config authoring).
type BuildResolvedLocaleInput = {
  code: LocaleCode;
  source: ResolvedLocale["context"]["source"];
};

function getResolvedLocaleFields(
  code: LocaleCode,
): Pick<ResolvedLocale, "consent" | "metadata"> {
  const definition = getLocaleDefinition(code);

  return {
    consent: definition.consent,
    metadata: deriveLocaleMetadata(code),
  };
}

function buildResolvedLocale({
  code,
  source,
}: BuildResolvedLocaleInput): ResolvedLocale {
  return {
    ...getResolvedLocaleFields(code),
    context: { code, source },
  };
}

export { buildResolvedLocale };
